/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".eventContainer.isFullScreen[_ngcontent-%COMP%]{position:fixed;top:10px;left:10px;width:calc(100vw - 20px);height:calc(100vh - 20px)!important;z-index:10000000000}.steno.isFullScreen[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };

